// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  overflow-x: hidden;
}


.custom-modal {
  /* width: 25%; */
  max-width: 360px;
  padding: 0;
  border: none;
  margin-left: auto;
  margin-right: auto;
}
.custom-modal .modal-content {
  border: none;
  border-radius: 0;
}

.custom-modal-body {
  width: 100%;
  border: none;
}
.error-message {
  color: red;
  font-size: small;
}
.closebutton {
  border: none;
  padding: 0;
  background-color: transparent;
}
.input-field {
  background-color: #f5f5f5;
  box-shadow: none;
  border: none;
  /* width: 85%; */
  /* height: 40px; */
}

.link {
  color: black;
  font-weight: bold;
  font-size: small;
}

.btn-lg {
  width: 100%;
  background-color: #17af4b;
  color: white;
}

.loginHeading h2 {
  font-weight: bold;
  font-size: x-large;
  margin-bottom: 10px;
}
.OTP-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
}

.otpBoxStyle {
  border: 2px solid #17af4b;
  outline: none;
  width: 13%;
  height: 50px;
  color: #000000;
  font-size: 14px;
  border-radius: 15px;
  background: #eeeeee;
  text-align: center;
  margin-bottom: 8px;
  margin-right: 1%;
}
p {
  font-size: small;
}

.mid-box-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.termstextcontainer {
  align-items: center;
  text-align: center;
}
.resendOtp {
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
}
@media (max-width: 576px) {
  .loginHeading h2 {
    font-size: large;
  }

  p {
    font-size: smaller;
  }
}

@media (min-width: 576px) {
  .left-side {
    display: none;
  }
}

@media (min-width: 769px) and (max-width: 991px) {
  .left-side .custom-logo,
  .left-side .signInImg {
    width: 100%;
  }

  .right-side-box {
    width: 80%;
  }
}

@media (min-width: 992px) and (max-width: 1200px) {
  .left-side .custom-logo,
  .left-side .signInImg {
    width: 100%;
  }

  .right-side-box {
    width: 80%;
  }
}
.mid-box-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/signinmodal/styles.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;;AAGA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,UAAU;EACV,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,UAAU;EACV,YAAY;EACZ,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;;IAEE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB","sourcesContent":["body {\n  overflow-x: hidden;\n}\n\n\n.custom-modal {\n  /* width: 25%; */\n  max-width: 360px;\n  padding: 0;\n  border: none;\n  margin-left: auto;\n  margin-right: auto;\n}\n.custom-modal .modal-content {\n  border: none;\n  border-radius: 0;\n}\n\n.custom-modal-body {\n  width: 100%;\n  border: none;\n}\n.error-message {\n  color: red;\n  font-size: small;\n}\n.closebutton {\n  border: none;\n  padding: 0;\n  background-color: transparent;\n}\n.input-field {\n  background-color: #f5f5f5;\n  box-shadow: none;\n  border: none;\n  /* width: 85%; */\n  /* height: 40px; */\n}\n\n.link {\n  color: black;\n  font-weight: bold;\n  font-size: small;\n}\n\n.btn-lg {\n  width: 100%;\n  background-color: #17af4b;\n  color: white;\n}\n\n.loginHeading h2 {\n  font-weight: bold;\n  font-size: x-large;\n  margin-bottom: 10px;\n}\n.OTP-container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.otpBoxStyle {\n  border: 2px solid #17af4b;\n  outline: none;\n  width: 13%;\n  height: 50px;\n  color: #000000;\n  font-size: 14px;\n  border-radius: 15px;\n  background: #eeeeee;\n  text-align: center;\n  margin-bottom: 8px;\n  margin-right: 1%;\n}\np {\n  font-size: small;\n}\n\n.mid-box-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.termstextcontainer {\n  align-items: center;\n  text-align: center;\n}\n.resendOtp {\n  font-weight: bold;\n  text-decoration: underline;\n  cursor: pointer;\n}\n@media (max-width: 576px) {\n  .loginHeading h2 {\n    font-size: large;\n  }\n\n  p {\n    font-size: smaller;\n  }\n}\n\n@media (min-width: 576px) {\n  .left-side {\n    display: none;\n  }\n}\n\n@media (min-width: 769px) and (max-width: 991px) {\n  .left-side .custom-logo,\n  .left-side .signInImg {\n    width: 100%;\n  }\n\n  .right-side-box {\n    width: 80%;\n  }\n}\n\n@media (min-width: 992px) and (max-width: 1200px) {\n  .left-side .custom-logo,\n  .left-side .signInImg {\n    width: 100%;\n  }\n\n  .right-side-box {\n    width: 80%;\n  }\n}\n.mid-box-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
